import { Button } from "@accurx/design";
import styled from "styled-components";

export const StyledButton = styled(Button)`
    flex: 1;
    justify-content: center;
`;
